import { render, staticRenderFns } from "./Modal-Ngvue.vue?vue&type=template&id=472ad4dc&scoped=true"
import script from "./Modal-Ngvue.vue?vue&type=script&lang=js"
export * from "./Modal-Ngvue.vue?vue&type=script&lang=js"
import style0 from "./Modal-Ngvue.vue?vue&type=style&index=0&id=472ad4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472ad4dc",
  null
  
)

export default component.exports